import React, { useContext } from 'react'
import { FormDataScientificDayContext, ShowScientificDayContext, modalType } from '../types'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { useTranslation } from 'react-i18next'
import { InputImages } from '../../../HtmlComponents/InputImages'

const InputsScientificDay = () => {
  const {
    theme, setTheme,
    RegFees, setRegFees,  
    createdAt, setCreatedAt,
    images, setImages

  } = useContext(FormDataScientificDayContext)

  const { t } = useTranslation()

  const { selectedModal } = useContext(ShowScientificDayContext)

  return (
    <>
      <InputElement name={t("Theme")} value={theme} setValue={setTheme}/>
      <InputElement name={t("Frais d'inscription")} value={RegFees} setValue={setRegFees}/>
      <InputElement type='date' name={t("Date")} value={createdAt} setValue={setCreatedAt}/>
      {selectedModal === modalType.AddModal && 
        <InputImages name="photos" setImages={setImages} accept="image/*" />      
      }
      <div className="grid grid-cols-4 gap-2">
        {images?.length > 0 && selectedModal === modalType.AddModal && 
          images.map((img: any, index: number) => (
            <img
              className="w-32 h-32"
              key={index}
              src={URL.createObjectURL(img)}
              alt={`${index + 1}`}
            />
          ))}
      </div>
    </>
  )
}

export default InputsScientificDay